(() => {
  angular
    .module('app.topmenu')
    .controller('TopMenuController', TopMenu);

  TopMenu.$inject = ['$cookies', '$location', 'OnboardingService'];

  function TopMenu($cookies, $location, OnboardingService) {
    const vm = this;

    // because the top menu is shown on every page that matters,
    // it makes sense to inject the Onboarding service here
    if ($cookies.get('showOnboarding') == 1) {
      const showOnboarding = localStorage.getItem('showOnboarding');
      const diff = showOnboarding ? new Date() - new Date(showOnboarding) : 0;

      if (!showOnboarding || (diff > 1000 * 3600 * 24)) {
        OnboardingService.displayLatest();
        //delete session cookie to avoid displaying on refresh
        $cookies.remove('showOnboarding');
      }
    }

    activate();
    function activate() {
      var absoluteUrl = $location.absUrl();
      var path = absoluteUrl.replace($location.host(),'');
      var lastView = $cookies.get('lastview');

      if (isPage(path, 'report/')) {
        lastView = absoluteUrl;
        $cookies.put('lastview', lastView, {
          path: '/'
        });
      } else if (isPage(path, 'campaign/edit/')) {
        lastView = absoluteUrl.replace(/campaign\/edit\/([0-9]*)\/?.*/, 'report/$1');
        $cookies.put('lastview', lastView, {
          path: '/'
        });
      }

      vm.lastView = lastView;
    }

    function isPage(path, name) {
      return path.indexOf(name) != -1;
    }

  }
})();
